import PageHeader from 'components/UI/PageHeader';
import ScrollToTop from 'components/UI/ScrollToTop';
import { ProductContext, ProductLarge } from 'product';
import React from 'react';
import { useLocation } from 'react-router';
function ProductPage() {
    var _a;
    const location = useLocation();
    const parentProductContext = (_a = location.state) === null || _a === void 0 ? void 0 : _a.parentContext;
    return (React.createElement(ProductContext.Provider, { value: { context: 'ProductPage', parentContext: parentProductContext } },
        React.createElement("div", { className: "product-page" },
            React.createElement(ScrollToTop, null),
            React.createElement(PageHeader, null),
            React.createElement(ProductLarge, null))));
}
export default ProductPage;
